export default "__VITE_ASSET__CEq1EIuL__"